import { cn } from "~/utils";

export type InputProps = {
  type?: string;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  size?: "sm" | "bg";
  className?: string;
  inputMode?:
    | "none"
    | "text"
    | "decimal"
    | "numeric"
    | "tel"
    | "search"
    | "email"
    | "url";
  step?: string | number;
  min?: string | number;
};

const Input = ({
  type = "text",
  size = "bg",
  placeholder,
  value,
  onChange,
  disabled,
  className,
  inputMode,
  step,
  min,
}: InputProps) => {
  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      disabled={disabled}
      inputMode={inputMode}
      step={step}
      min={min}
      className={cn(
        "bg-beige-500 rounded-full outline-none pl-6 pr-4 border border-beige-500 active:border-black focus:border-black",
        {
          "py-2": size === "bg",
          "py-4": size === "sm",
          "bg-grey-100 border-grey-100": disabled,
        },
        className
      )}
    />
  );
};

export default Input;
